export default __webpack_public_path__ + "static/media/facebook-logo.0caf4d90.svg";